import React from 'react'
import TextField from '@material-ui/core/TextField'
import ExpandablePanel from '../../components/controls/ExpandablePanel'
import { controlHasError } from '../../lib/errorHandler'
import PrintText from '../../lib/PrintText'

export default function OmowienieZasad(props) {
  return (
    <ExpandablePanel title="PRZYJĘTE ZASADY (POLITYKI) RACHUNKOWOŚCI, W ZAKRESIE W JAKIM USTAWA POZOSTAWIA JEDNOSTCE PRAWO WYBORU">
      <form autoComplete="off" className="subsection">
        {props.czyPodsumowanie ? (
          <PrintText
            text={props.data.OmowienieZasad}
          />
        ) : (
          <TextField
            error={controlHasError(
              props.errors,
              'OmowienieZasad',
              props.data.OmowienieZasad,
            )}
            name="OmowienieZasad"
            label="Opis"
            multiline
            variant="outlined"
            title={props.data.OmowienieZasad}
            defaultValue={props.data.OmowienieZasad}
            onBlur={(e) =>
              props.onSetSectionData('OmowienieZasad', e.target.value)
            }
          />
        )}
      </form>
    </ExpandablePanel>
  )
}
